import { ApplicationUser } from "../types/user";
import { baseFetch, HttpVerbs } from "./baseFetch";
import { endpoints } from "./endpoints";





 const getUserProfile = async () : Promise<ApplicationUser> =>{

    const url = `${endpoints.getUserProfile}`;
    const response = await baseFetch<ApplicationUser>({
      endpointUrl: url,
      httpVerb: HttpVerbs.GET
    });
    if (response instanceof Error) {
        // Handle not existing user case here
        throw response;
    }

    return response as ApplicationUser;
}




export { getUserProfile };